<template>
    <div class="home">
      <main class="main" data-v-109a143a="">
        <div data-v-1f4d0977="" class="privacy-view">
          <header data-v-1f4d0977="">
            <div  class="container">
              <h1 data-v-1f4d0977="">用户协议</h1>
            </div>
          </header>
          <main data-v-1f4d0977="">
            <div data-v-1f4d0977="" class="container">
              <section data-v-1f4d0977="" class="intro">
                <h2 data-v-1f4d0977="" style="text-align: left;">导言及协议生效</h2>
                <p data-v-1f4d0977="" style="text-align: left;">欢迎使用由深圳市香港乾元有限公司跨境电商责任有限公司开发并运营的香港乾元有限公司ERP软件及服务。本软件专为沃尔玛 Marketplace 卖家及跨境电商从业人员设计，作为沃尔玛认证的 Solution Provider（解决方案服务商）ERP 软件，旨在通过以目标为导向的流程管理、清晰的决策逻辑和准确及时的数据、实时准确的预警功能等，助力用户实现精细化运营。</p>
                <p data-v-1f4d0977="" style="text-align: left;">在注册并使用香港乾元有限公司前，请务必仔细阅读并充分理解《香港乾元有限公司用户协议》的所有条款。若您点击“同意并注册”或通过其他方式确认接受本协议，即视为您已完全理解并同意受本协议约束。本协议自您完成注册时生效。</p>
                <p data-v-1f4d0977="" style="text-align: left;">若您代表实体公司使用本软件，则您声明已获得该实体的合法授权，并承诺遵守本协议及中国相关法律法规。</p>
              </section>
              <section data-v-1f4d0977="" class="policy">
                <h2 data-v-1f4d0977="" style="text-align: left;">一、 禁止的活动</h2>
                <p data-v-1f4d0977="" style="text-align: left;">任何客户或其他服务使用者通过某项服务的实行或参与下列所述任何活动都违背了香港乾元有限公司科技政策（不论这些活动是实际或企图进行的，无论是直接还是间接的）。以下所列出的任何行为（每个行为，称“禁止的活动”）均构成对店步秘网络服务的滥用和对其他客户的干扰。这些行为是严禁的：</p>
                <ul data-v-1f4d0977="" style="text-align: left;">
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(a).</strong>广告、传送或以其他方式获取违反AUP的任何软件、程序、产品或服务，包括但不限于从事或促进用来发送未经许可的商业资讯或任何形式的通信或未经许可的大宗邮件（“SPAM”）的工具，运行 Ping 命令、洪水袭击以及拒绝服务攻击等；
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(b).</strong>伪造用户或其他服务工具，这些服务是提供给XXX科技或其他服务用户或用于从事在于保留或掩盖客服或期终端用户身份或联系任何活动或行为，包括但不限于故意泄露、删除、仿造或误传重要信息，例如：客户经营信息、订单信息、产品信息、运营数据等；
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(c).</strong> 从事任何其他活动，该活动：
-违反法律或法规，包括但不限泄露用户数据、侵犯用户隐私、贩卖重要商业数据、色情相关产品、盗用版权、仿牌仿品、注册商标、专利、商业秘密或有其他知识产权；
-违反相关特许协议下XXX科技的独有权；
-威胁任何网络或电脑系统的完整性或安全，包括但不限于传播病毒、特洛伊木马、蠕虫病毒、邮件炸弹、按键记录、间谍软件、广告软件或任何有害的程序或设计于负面影响电脑软件或硬件操作的类似电脑代码；
-目的在于任何方式危害或试图危害未成年人；
-试图以一种逃避税费或其他要求就使用而缴费的方式使用服务；
-以其他方式降低或干扰其他用户使用某项服务；
-违反应向第三方承担的任何法定义务，如契约义务或应尽的义务；
-违反国际网络或其他网络行为和使用的通常公认标准，包括但不限于修改网页、网络扫描以及未授权的系统渗透。
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(d).</strong>通过利用其他提供者的服务从事任何上述活动，但通过某个XXX科技账户、邮件代理或其他方式通过某项服务引导活动的除外。任何客户或客户的最终用户或代表任何客户或客户的最终用户间接地违反该AUP或违反该AUP未遂的，以及任何第三方代表任何客户或客户的终端用户实际违反该AUP或违反该AUP未遂的，都将视为该客户或客户的最终用户违反该AUP。
                  </li>
                </ul>
              </section>
              <section data-v-1f4d0977="" class="policy">
                <h2 data-v-1f4d0977="" style="text-align: left;">二、 权利和补救措施</h2>
                <p data-v-1f4d0977="" style="text-align: left;">如果XXX科技认定任何客户、其代表或最终用户已违反或未遵守该AUP或从事（或允许他人从事）任何禁止的活动，则XXX科技可采取其认为适宜的措施。这可以包括以下全部或任何内容：</p>
                <ul data-v-1f4d0977="" style="text-align: left;">
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(1).</strong>随时暂停和/或终止该客户的服务；
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(2).</strong>向该客户进行警告；
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(3).</strong> 向该客户进行法律程序，在要求赔偿的基础上要求赔偿因违反该AUP而产生的所有费用（包括但不限于合理的行政管理费用和法律费用）；
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(4).</strong>出于保护客户的系统和网络资源的目的，拒绝来自那些支援违法活动的已知IP位置区的所有通信；
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(5).</strong>对客户采取进一步法律行动；并且
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">(6).</strong> 如果是非法行为，调查并通知相关司法部门。如果XXX科技收到法院指令，要求其向某人揭露客户的身份，而该人控诉该客户滥用服务，则XXX科技有权这样做。如果法律要求XXX科技向警方或其他公职机关揭露客户的身份或XXX科技拥有的关于服务使用的其他资料，则XXX科技也有权揭露。
XXX科技将根据各人的价值，考虑所有情况和投诉。XXX科技有权不向客户采取行动，即使投诉是针对客户违反该AUP而提出的。
如可行及法律允许的话，XXX科技保留采取技术手段来避免发生所禁止活动的权力。而且，XXX科技保留向客户收取其进行禁止活动有关的行政管理费用的权力，包括但不限于支付确认违约者及拆除或中断其服务的过程中产生的费用，收取的金额相当于XXX科技防止或回应该活动实际产生的费用。
该AUP中没有任何内容可以限制XXX科技对于任何被禁止活动的法律权力和补救措施。
该AUP不影响适用于国际网络服务的条款与条件，这些国际网络服务由XXX科技于XXX科技网络范围内提供。
                  </li>
                </ul>
              </section>
              <section data-v-1f4d0977="" class="policy">
                <h2 data-v-1f4d0977="" style="text-align: left;">三、 密码保护</h2>
                <p data-v-1f4d0977="" style="text-align: left;">客户负责保护其个人的密码，并且对于任何授权的或未授权的使用其密码负责。没有书面的授权，客户不得透露其密码或使用或允许任何人使用XXX科技服务来推测密码或进入其他系统或网络。如果某个网络或网络设备受到危害，XXX科技完全有权自行决定协助进行追查并且/或在网络层面以XXX科技认为合理的程序逐出该违约者。</p>
              </section>
              <section data-v-1f4d0977="" class="policy">
                <h2 data-v-1f4d0977="" style="text-align: left;">四、 AUP 的执行性及修改</h2>
                <p data-v-1f4d0977="" style="text-align: left;">如果该AUP的任何条款或其任何部分出于任何原因被宣布无效，则有抵触的词句应视为已被删除，而其他条款应继续保持完全有效。</p>
                <p data-v-1f4d0977="" style="text-align: left;">香港乾元有限公司科技保留随时更新该AUP而无需通知的权力，更新自公布在网站开发者官网.com上起生效。</p>
              </section>
              <section data-v-1f4d0977="" class="policy">
                <h2 data-v-1f4d0977="" style="text-align: left;">五、 客户支持和个人信息保护</h2>
                <ul data-v-1f4d0977="" style="text-align: left;">
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">PII信息处理政策：</strong>香港乾元有限公司科技将制定并实施一项明确的政策，规定在客户支持过程中处理个人身份信息（PII）的流程。该政策将确保在提供客户支持后，所有包含PII的信息必须被及时删除。
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">信息删除流程：</strong>公司将建立一个标准化的流程，用于在问题解决后删除所有通过电子邮件、电话、屏幕截图或其他方式提供的包含PII的信息。此流程将包括但不限于以下步骤：
                    客户支持团队在问题解决后立即通知客户需要删除PII。 客户提供删除确认或自行删除PII的证据。 如果客户无法自行删除，公司将采取措施帮助或代替客户完成删除。
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">临时审查机制：</strong> 检查客户支持记录，确保PII信息在问题解决后已被删除。 评估客户支持团队对政策的遵守情况。 识别并解决任何潜在的PII信息处理不当的问题。
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">员工培训和意识：</strong>公司将对所有员工进行定期培训，提高他们对保护PII信息重要性的认识，并确保他们了解并能够遵循公司的政策和流程。
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">违反政策的后果：</strong>如果发现员工或客户违反了PII信息处理政策，公司将采取适当的纪律措施，并可能涉及法律行动。
                  </li>
                  <li data-v-1f4d0977="">
                    <strong data-v-1f4d0977="">透明度和沟通：</strong>香港乾元有限公司科技将向所有客户和合作伙伴清晰地传达这一政策，并在必要时提供指导，以确保他们了解如何在与公司互动时保护PII信息。
                    政策更新和通知：公司将定期审查和更新PII信息处理政策，以确保其符合最新的法律法规和行业最佳实践。任何政策变更都将及时通知所有相关方。
                  </li>
                </ul>
                </section>
              <section data-v-1f4d0977="" class="policy">
                <h2 data-v-1f4d0977="" style="text-align: left;">六、 适用法律和管辖许可权</h2>
                <p data-v-1f4d0977="" style="text-align: left;">本政策受中华人民共和国法律的管辖，双方完全服从中华人民共和国法庭的管辖。</p>
                <p data-v-1f4d0977="" style="text-align: left;">本政策遵循欧盟通用数据保护条例 (GDPR)，双方在欧盟区域的业务完全服从欧盟通用数据保护条例 (GDPR)的约束。</p>
                <p data-v-1f4d0977="" style="text-align: left;">本政策遵循美国加州消费者隐私法 (CCPA)，双方在美国区域的业务完全服从美国加州消费者隐私法 (CCPA)的约束。</p>
                <p data-v-1f4d0977="" style="text-align: left;">本政策遵循 Walmart Marketplace API 开发者条款及 Walmart Solution Provider 相关协议</p>
              </section>
            </div>
          </main>
        </div>
      </main>
    </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style scoped>
  .en-main[data-v-109a143a],
  .footer[data-v-109a143a],
  .main[data-v-109a143a] {
    width: 100%;
  }
  main {
    display: block;
    unicode-bidi: isolate;
  }
  main[data-v-1f4d0977] {
      margin-top: 1.25rem;
  }
  .privacy-view[data-v-1f4d0977] {
      padding: 1.25rem;
      background-color: #fff;
      border-radius: .625rem;
      box-shadow: 0 0 .625rem rgba(0, 0, 0, .1);
      width: 75rem;
      margin: 3.125rem auto;
  }
  header[data-v-1f4d0977] {
      background-color: #036;
      color: #fff;
      padding: 0.9rem 0;
  }
  header .container[data-v-1f4d0977] {
      text-align: center;
  }
  header h1[data-v-1f4d0977] {
      margin: 0;
      color: #fff;
      font-size: 16px;
  }
  main .container[data-v-1f4d0977] {
      max-width: 62rem;
      margin: 0 auto;
      background-color: #fff;
      padding: 1.25rem;
      border-radius: .5rem;
      box-shadow: 0 .125rem .625rem rgba(0, 0, 0, .1);
  }
  section {
      display: block;
      unicode-bidi: isolate;
  }
  section h2[data-v-1f4d0977] {
      font-size: 1.5rem;
      margin-bottom: .625rem;
      color: #036;
  }
  section p[data-v-1f4d0977] {
    font-size: 11px;
      margin-bottom: .9375rem;
  }
  p {
      display: block;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      unicode-bidi: isolate;
  }
  section ul[data-v-1f4d0977] {
      list-style-type: disc;
      margin-left: 1.25rem;
      list-style: none;
  }
  section ul li[data-v-1f4d0977] {
      margin-bottom: .625rem;
      font-size: 13px;
  }
  </style>